import * as React from 'react';
// import { lazyInject } from '../../../services/inversify';
// import { TriggerService } from '../../../core/trigger/trigger_service';
import { IDs } from '../../../helpers/IDs';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';

interface BeraterBereicheProps extends React.ClassAttributes<any> {
    data: any;
}

interface BeraterBereicheState {
    beraterTid: number;
    dataBeraterBereiche: Array<any>
}

export class BeraterBereiche extends React.Component<BeraterBereicheProps, BeraterBereicheState> {

    constructor(props: any) {
        super(props);
        this.state = {
            beraterTid: null,
            dataBeraterBereiche: null
        };

        this.validateField = this.validateField.bind(this);
        this.getFilteredBereiche = this.getFilteredBereiche.bind(this);
    }

    render(): JSX.Element {
        const { beraterTid } = this.state;

        const customFormatter = (key: string, value: any, data: any, row: any) => {
            if (value === undefined || value === null) {
                return '';
            }
            if (key === 'berater') {
                if (data.berater_orig > 0) {
                    const berater = this.props.data[IDs.ENT_BERATER];
                    const fnd = berater.find((r: any) => r.tid === data.berater_orig);
                    if (fnd) {
                        return <div style={{ padding: 3 }}>
                            <div style={{ fontWeight: 'bold' }}>{fnd.name}</div>
                            <div>{fnd.mail}</div>
                            <div>{fnd.bereich_key}</div>
                        </div>;
                    }
                }
            }
            return value;
        };

        return (
            <div>
                <WFormsTableWrapper
                    entity={IDs.ENT_BERATER_BEREICHE}
                    module={IDs.MOD_ETOOL_ADMIN}
                    actions={['add', 'delete']}
                    formLayout={'flowV2'}
                    customClass={'Custom-ETA'}
                    showColumnsHelp={true}
                    customFormatter={customFormatter}
                    onDataLoaded={(dataBeraterBereiche: any) => this.setState({ dataBeraterBereiche })}
                    validRestriction='stop'
                    validateField={this.validateField}
                    bundleFilterFunc={(bundle: any) => {
                        bundle.bereich_key = this.getFilteredBereiche(beraterTid);
                        return bundle;
                    }}
                    onAfterAction={(action: string) => {
                        if (action.startsWith('closeForm')) {
                            this.setState({ beraterTid: null });
                        }
                    }}
                    defaultSorted={[{ id: 'berater', asc: true }, { id: 'bereich_key', asc: true }]}
                    customCssStyle={{
                        formFieldSelect: {
                            berater: {
                                selectStyle: { height: 60 }
                            }
                        }
                    }}
                />
            </div>
        );
    }

    validateField(key: string, value: any, data: any, onValueChange: (name: string, value: any, doValidate?: boolean) => void): string {
        if (key === 'berater') {
            const beraterTid = value;
            const bereichKey = data.values.bereich_key;
            if (this.state.beraterTid !== beraterTid) {
                const berater = this.props.data[IDs.ENT_BERATER].find((r: any) => r.tid === beraterTid);
                if (berater) {
                    if (!berater.bereich_key_orig) {
                        onValueChange('bereich_key', null, false);
                        return 'Bitte dem ausgewählten Berater erst einen Hauptbereich im Tab "Berater" zuordnen!';
                    } else {
                        this.setState({ beraterTid });
                        const bundleBereiche = this.getFilteredBereiche(beraterTid);
                        if (bereichKey && !bundleBereiche.find((r: any) => r.intern_key === bereichKey)) {
                            onValueChange('bereich_key', null, false);
                        }
                        if (bundleBereiche.length === 0) {
                            return "Dem ausgewählten Berater darf keinen weiteren Bereich zugeordnet werden.";
                        }
                    }
                }
            }
        }
        return null;
    }

    getFilteredBereiche(beraterTid: number) {
        const { data } = this.props;
        const { dataBeraterBereiche } = this.state;
        let bundleBereiche = [...(data.berater_bundle.bereich_key || [])];
        if (beraterTid > 0 && Array.isArray(data[IDs.ENT_BERATER])) {
            const berater = data[IDs.ENT_BERATER].find((r: any) => r.tid === beraterTid);
            if (berater) {
                const hauptBereich = berater.bereich_key_orig;
                if (!hauptBereich) {
                    bundleBereiche = [];
                } else {
                    bundleBereiche = bundleBereiche.filter((r: any) => r.intern_key !== hauptBereich
                        && !dataBeraterBereiche.find((b: any) => b.berater_orig === beraterTid && b.bereich_key_orig === r.intern_key));
                }
            }
        }
        // console.log(bundleBereiche);
        return bundleBereiche;
    }
}
